import React, { useEffect, useState } from 'react';
import Loading from '../loading/Loading'
import Swal from 'sweetalert2';
import ToggleSwitch from './ToggleSwitch';
import axios from 'axios';
import MyModal from '../modal/MyModal'
import { format } from 'date-fns';
import {
  Typography, TablePagination,
  Table, TableBody, TableCell,
  TableHead, TableRow, TableContainer,
} from "@mui/material";


function AdminAdvertisementList({ garagesList, actions }) {
  const [loading, setLoading] = useState(true);
  const [loadingText, setLoadingText] = useState('Loading Advertisements, Please Wait...')


  const showTime =format(new Date(), 'MMddyyyyHis');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchInput, setSearchInput] = useState('');
  const [filteredGarages, setFilteredGarages] = useState([]);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };


  const handleSearch = () => {
    const filtered = garagesList.filter((garage) => {
      const searchValue = searchInput.toLowerCase();

      const searchProperties = [
        garage.ownerEmail,
        garage.firstname,
        garage.lastname,
        garage.businessName,
        garage.businessLicense,
        garage.email,
        garage.phoneNumber,
        garage.businessURL,
        garage.ZipCodes,
        garage.PaymentType,
        garage.startDate,
        garage.endDate,
      ];

      return searchProperties.some((property) => {
        if (typeof property === 'string' && property.toLowerCase().includes(searchValue)) {
          return true;
        } else if (typeof property === 'number' && property.toString().includes(searchValue)) {
          return true;
        }
        return false;
      });
    });

    setFilteredGarages(filtered);
  };


  const garagesToDisplay = searchInput ? filteredGarages : garagesList;
  const usersToShow = garagesToDisplay.slice(page * rowsPerPage, (page + 1) * rowsPerPage);
  useEffect(() => {

    if (garagesList && Object.keys(garagesList).length) {
      const getGaragesComponents = (garage, element) => {

      };

      async function getGarages(garagesList) {
        let garagesContainer = [];
        try {
          for (const garage in garagesList) {
            const element = garagesList[garage];
            garagesContainer.push(getGaragesComponents(garage, element));
          }
          return garagesContainer;
        } catch (err) {
          throw err;
        }
      }

      getGarages(garagesList).then(resp => {

        if (resp.length > 0) {
          setLoading(false);
        } else {
          setLoading(true);
          setLoadingText("Oops, no garages found");
        }
      });
    } else {

      setLoading(() => false);
    }
  }, [garagesList, actions])


  function approveFun(key, ToggleValue) {
    console.log(ToggleValue)
    Swal.fire({
      title: 'Are you sure?',
      text: `You want to ${ToggleValue ? 'Disapprove' : 'approve'} this Advertisement!`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: `Yes,  ${ToggleValue ? 'Disapprove' : 'approve'} it!`
    }).then(async (result) => {
      if (result.value) {
        Swal.fire({
          title: 'Updating Status, please wait',
          html:
            '<div class="loadingio-spinner-rolling-w23e05eix9"><div class="ldio-ik6pzj2wupc"><div></div></div></div>',
          showConfirmButton: false,
          showCancelButton: false,
          focusConfirm: false,
        });

        console.log(ToggleValue)
        const approveStatus = !ToggleValue ? 1 : 2;
        axios.post(`${process.env.REACT_APP_API_URL}`, { action: 'UpdateAdminStatus', approveStatus: approveStatus, id: key })
          .then(response => {
            Swal.fire({
              icon: 'success',
              text: response.data.message,
              title: 'success'
            }).then(() => {
              window.location.reload();
            })
          })
          .catch(error => {
            Swal.fire(
              'There were a problem',
              error ? 'Error fetching data:' + error : 'Please, try again or contact SAGE Parents',
              'error'
            )
            console.error('Error fetching data:', error);
          });

      }
    })
  }

  return (loading ?
    <Loading text={loadingText} />
    :
    <>
      <div className="col-md-12 d-flex">
        <input
          className='form-control w-25 mx-2 py-2'
          type="text"
          placeholder="Search Advertisement"
          value={searchInput}
          onChange={(e) => setSearchInput(e.target.value)}
        />
        <button onClick={handleSearch}
          className='btn btn-outline-success  py-2'>Search</button>
      </div>
      <TableContainer
        className='table'
        sx={{
          width: {
            xs: "274px",
            sm: "100%",
          },
        }}
      >
        <Table
          aria-label="simple table"
          sx={{
            whiteSpace: "nowrap",
            mt: 2,
          }}
        >
          <TableHead>
            <TableRow>
              <TableCell>
                <Typography color="textSecondary" variant="h6">Image
                </Typography>
              </TableCell>
              <TableCell>
                <Typography color="textSecondary" variant="h6">Business Details
                </Typography>
              </TableCell>
              <TableCell>
                <Typography color="textSecondary" variant="h6">ZipCode
                </Typography>
              </TableCell>
              <TableCell>
                <Typography color="textSecondary" variant="h6">Date
                </Typography>
              </TableCell>
              <TableCell>
                <Typography color="textSecondary" variant="h6">Status
                </Typography>
              </TableCell>
              <TableCell>
                <Typography color="textSecondary" variant="h6">View
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {usersToShow.map((element, index) => (

              <TableRow key={index}>
                <TableCell className="image-ads">
                  <img width={100}
                    className="garage__image" src={`${element.picture ? `${process.env.REACT_APP_UPLOAD_URL + element.picture}?time=${showTime}` : './assets/Images/garage-placeholder.png'}`}
                    alt='imagesURL' 
                    style={{ transform: `rotate(${element.pictureA ? element.pictureA : 0}deg)` }}
                    />
                </TableCell>

                <TableCell>
                  <Typography color="textSecondary" variant="h6">
                  Owner Email : {element.ownerEmail ? element.ownerEmail : ''}<br />
                    Business Name : {element.businessName ? element.businessName : ''}<br />
                    URL : {element.businessURL ? element.businessURL : ''}<br />
                    License : {element.businessLicense ? element.businessLicense : ''}<br />
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography color="textSecondary" variant="h6">
                    {element.ZipCodes.map((item, index) => (
                      (item !== "" &&
                        <div key={index}>
                          <p>{item}</p>
                        </div>
                      )
                    ))}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography color="textSecondary" variant="h6">
                    {format(new Date(element.startDate), 'MM/dd/yyyy')}
                    {element.endDate === '0000-00-00 00:00:00' ?
                      '' :
                      `- ${element.endDate !== '0000-00-00 00:00:00' ? format(new Date(element.endDate), 'MM/dd/yyyy') : ''}`
                    }
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography color="textSecondary" variant="h6">
                    {element.userStatus === false ? (
                      <div>
                        Disabled by User<br />
                      </div>
                    ) : (
                      ''
                    )}
                    <ToggleSwitch
                      onlabel="Disapprove"
                      offlabel="Approve"
                      onClick={() => approveFun(element.id, element.approveStatus === 1 ? true : false)}
                      checked={element.approveStatus === 1 ? true : false} />

                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography color="textSecondary" variant="h6">
                    <MyModal elements={element} />
                  </Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer >
      <TablePagination
        component="div"
        count={garagesList.length}
        page={page}
        onPageChange={handleChangePage}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </>
  )
}

export default AdminAdvertisementList